import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SxHttpService } from './sxHttp.service';
import { of } from 'rxjs/observable/of';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { ResponseContentType } from '@angular/http';

export interface RequestConfiguracionEndosoDTO {
  codPoliza?: string;
  comando?: string;
  idCertificado: number;
  idPoliza: number;
};

export interface RequestConfiguracionUsuarioDTO {
  comando: string;
};


export interface ImportacionMasiva {
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  tipoImportacion: string;
  archivo?: any;
  requestConfiguracionUsuario?: RequestConfiguracionUsuarioDTO;
  requestConfiguracionEndoso?: RequestConfiguracionEndosoDTO;
  tarifaV5_Tipo?: string;
  tarifaV5_IdTabla?: number;
};

@Injectable()
export class ImportacionMasivaService {
  private url = 'api/importacionMasiva';

  constructor(private sxHttp: SxHttpService) { }

  enviarDatosImportacion(importacion: ImportacionMasiva): Promise<any> {
    const url = `${this.url}/SubirArchivo`;

    return this.sxHttp.post(url, importacion)
      .map(response => response.json().data as any)
      .toPromise();
  }

  generarLayout(importacion: ImportacionMasiva): Promise<any> {
    const url = `${this.url}/GenerarLayout`;
    return this.sxHttp.post(url, importacion)
      .map(response => response.json().data as any)
      .toPromise();
  }

  descargarLayout(fileName: string): Promise<any> {
    const url = `${this.url}/DescargarLayout`;
    return this.sxHttp.get(url, { fileName })
      .map(response => response.json().data as any)
      .toPromise();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/importacionMasiva.service.ts